import { render, staticRenderFns } from "./Overduelist.vue?vue&type=template&id=b5ee9898&scoped=true"
import script from "./Overduelist.vue?vue&type=script&lang=js"
export * from "./Overduelist.vue?vue&type=script&lang=js"
import style0 from "./Overduelist.vue?vue&type=style&index=0&id=b5ee9898&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ee9898",
  null
  
)

export default component.exports